import { Inject, Injectable, forwardRef } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { HttpClient } from './http-client.service';
import { Observable } from 'rxjs/Observable';
import { Language } from '../../entities/language';
import { Settings } from '../../settings';
import { ODataBuilder } from '../../utility/odata/odata-builder';
import { CachedCallService } from './cached-call.service';
import { GoalsPopup } from '../../entities/goals-popup';

@Injectable()
export class GoalsPopupService {
  private readonly headers: Headers = new Headers({ 'Content-Type': 'application/json' });
  private readonly options: RequestOptions = new RequestOptions({ headers: this.headers });

  private static readonly goalsPopupUrl: string = `${Settings.apiUrl}/v1/GoalsPopupSettings`;

  public goalsPopup = new GoalsPopup();

  constructor(@Inject(forwardRef(() => HttpClient)) private http: HttpClient) { }

  getGoalsPopupSettings(): Promise<GoalsPopup> {
    let oDataBuilder: ODataBuilder = new ODataBuilder(GoalsPopupService.goalsPopupUrl);
    let goalsPopupUrl: string = oDataBuilder.toString();


    return this.http.get(goalsPopupUrl)
      .toPromise()
      .then(response => {
        this.goalsPopup = response.json() as GoalsPopup;
        return this.goalsPopup;
      });
  }

  updateGoalsPopup(model: GoalsPopup): Promise<number> {
    let goalsPopupUrl: string = `${Settings.apiUrl}/v1/GoalsPopupSettings`;
    return this.http.post(goalsPopupUrl, JSON.stringify(model), this.options)
      .toPromise()
      .then(response => {
        return response.status as number;
      });
  }
} 



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/ng-router-loader?{"loader":"async-system","genDir":"compiled","aot":false}!./src/app/services/http/goals-popup.service.ts